<section class="content full-height">
    <div class="content-block">
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="card welcome-card" style="background: none;">
                    BIENVENUE CHEZ {{user?.filiale_libelle}}
                </div>
            </div>
        </div>
    </div>
</section>
